import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:applicationName(home|fede)?/:productType?/:productCode?/:productTerm?/:action?',
    name: 'FENG',
    component: () => import('../views/Page.vue'),
    meta: {
      requiresAuth: true,
      updateRoutePathOnSave: true,
      clearCache: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
